// Generated by purs version 0.13.8
"use strict";
var getLayoutRect = function (e) {
    return e.layout;
};
module.exports = {
    getLayoutRect: getLayoutRect
};
